const getClientValueForSelect = (
  curr_value: string,
  values?: { code: string; company_name: string }[],
): { value: string; label: string } | undefined => {
  const client = values?.find(v => v.code === curr_value);

  return (
    client && {
      value: client.code,
      label:
        client.code === 'ALL'
          ? 'Todos'
          : `(${client.code}) - ${client.company_name}`,
    }
  );
};

export default getClientValueForSelect;
